import type { PlanChargeStatus } from '@practium/features/api';
import { getChargeStatusLabel } from '../../utils/formatMyPlan';
import styles from './ChargeStatusBadge.module.css';

interface ChargeStatusBadgeProps {
	status: PlanChargeStatus;
}

export const ChargeStatusBadge = ({ status }: ChargeStatusBadgeProps) => {
	const tone =
		status === 'paid'
			? styles.paid
			: status === 'canceled' || status === 'failed'
				? styles.canceled
				: status === 'refunded'
					? styles.refunded
					: styles.processing;

	return <span className={`${styles.badge} ${tone}`}>{getChargeStatusLabel(status)}</span>;
};
